import UserInput from 'v3/common/components/UserInput';
import { FC, FormEvent } from 'react';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';
import _ from 'lodash';
import { BrokerSpecificComponentsProps } from '../../../types.type';

const CoinDcx: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles, switchPage }) => {
  const {
    reDirectPage,
    validateClientId,
    changeApiKey,
    updatePartialConfigs,
    isMobile,
    sendOtp,
    validateOtp,
  } = brokerSpecificHandles;
  const {
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    isLoading,
    isValidForm,
    selectedBrokerConfig,
    otp,
    isOtpSent,
    mobileNumber,
  } = userConfigs;
  const broker = selectedBrokerConfig?.id;

  const getLoginFlow = () => {
    if (!isClientValidated) return { label: 'Validate', action: validateClientId };
    if (isOtpSent && !shouldShowSecretKey)
      return { label: 'Verify OTP', action: validateOtp, params: [undefined, true] };
    if (shouldShowSecretKey) return { label: 'Login', action: reDirectPage };
    return { label: 'Send OTP', action: sendOtp };
  };

  const { label, action, params } = getLoginFlow();

  return (
    <form
      id={`broker-${broker}`}
      onSubmit={(e: FormEvent) => {
        e.preventDefault();
        action(...(params || []));
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Registered Mobile Number"
        id={`${broker}-mobile-number`}
        type="number"
        value={mobileNumber ?? ''}
        isDisabled={isClientValidated}
        onHandleChange={(value) =>
          updatePartialConfigs({ mobileNumber: value === '' ? null : _.toNumber(value) })
        }
      />
      {!isClientValidated && !mobileNumber && (
        <a href="https://invite.coindcx.com/19491484" target="_blank" rel="noreferrer">
          <button type="button">Open Account With CoinDCX</button>
        </a>
      )}
      {!isClientValidated && mobileNumber && (
        <button type="button" onClick={changeApiKey}>
          <i className="fa-regular fa-gear fa-spin" />
          Change API details?
        </button>
      )}
      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          placeholder="Enter API Key"
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}
      {shouldShowSecretKey && (
        <UserInput
          labelValue="API Secret"
          id={`${broker}-secret-key`}
          value={secretKey}
          type="password"
          placeholder="Enter API Secret"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}
      {isClientValidated && (
        <button type="button" onClick={() => switchPage()}>
          <img src="/gear.svg" alt="" />
          <span className="ms-2">How to generate API?</span>
        </button>
      )}

      {!isValidForm && <div className="alert alert-danger">Please provide the details</div>}

      {isOtpSent && (
        <>
          <UserInput
            labelValue="OTP"
            id={`${broker}-otp`}
            type="number"
            value={otp ?? ''}
            onHandleChange={(value: string) => updatePartialConfigs({ otp: value })}
          />
          <button type="button" onClick={() => sendOtp(true)}>
            <i className="fa-regular fa-gear fa-spin" />
            Re-Send OTP ?
          </button>
        </>
      )}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button type="submit" isLoading={isLoading} form={`broker-${broker}`}>
          {label}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default CoinDcx;
